<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/toolbox-icon.svg" alt="">
    </div>
    Tipo de mantención
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Nuevo Tipo de Mantención</h2>
    <a routerLink="/maintenance-types" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <form [formGroup]="maintenanceTypeForm" (ngSubmit)="onSubmit()">
      <div class="mb-4">
        <label for="name" class="block text-sm font-bold mb-2">Nombre<span class="text-danger-500">*</span>:</label>
        <input id="name" type="text" formControlName="name" class="input" placeholder="Nombre">
        <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger-500 text-sm">
          El nombre es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="viewTypeId" class="block text-sm font-bold mb-2">Tipo de Vista<span class="text-danger-500">*</span>:</label>
        <select id="viewTypeId" formControlName="viewTypeId" class="input">
          <option value="" disabled>Seleccione un tipo de vista</option>
          <option *ngFor="let viewType of viewTypes" [value]="viewType.id">{{ viewType.name }}</option>
        </select>
        <div *ngIf="viewTypeId.invalid && (viewTypeId.dirty || viewTypeId.touched)" class="text-danger-500 text-sm">
          El tipo de vista es obligatorio.
        </div>
      </div>
      <div *ngIf="errorMessage" class="mb-4 text-danger-500">
        {{ errorMessage }}
      </div>
      <div class="flex items-center justify-end">
        <button type="submit" class="button button-success">
          Crear Tipo de Mantención
        </button>
      </div>
    </form>
  </div>
</div>
